exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fab-button[data-v-6d0ba3f9]{position:fixed;bottom:40px;right:40px;z-index:100;width:60px;height:60px;border-radius:50px;box-shadow:2px 2px 3px rgba(0,0,0,.5);background:linear-gradient(60deg, #66bb6a, #43a047);transform:scale(1) rotate(0deg);transition:transform 200ms cubic-bezier(0.42, 0, 0.75, 1.54)\n}\n.fab-button.hide[data-v-6d0ba3f9]{transform:scale(0) rotate(-90deg)\n}", ""]);

// exports
